import { BrowserTokenStorage, SessionPkceStorage } from "@hicya/auth-sdk";
import { getBackendUrl } from "@hicya/ui/backend";

const DEFAULT_AUTH_URL: string = import.meta.env.VITE_AUTH_URL ?? "https://auth.hicya.org";
const DEFAULT_SYNC_URL: string =
  (import.meta.env.VITE_SYNC_URL as string | undefined) ?? "https://sync.hicya.org";

export const AUTH_URL = getBackendUrl("auth", DEFAULT_AUTH_URL);
export const AUTH_CLIENT_ID: string = import.meta.env.VITE_AUTH_CLIENT_ID ?? "habits";
export const REDIRECT_URI = window.location.origin + "/auth/callback";

export const SYNC_URL = getBackendUrl("sync", DEFAULT_SYNC_URL);

export const tokenStorage = new BrowserTokenStorage("habits");
export const pkceStorage = new SessionPkceStorage("habits");
